// Decodifica el payload de un JWT sin verificar la firma (solo para leer "exp"
// en el cliente; la verificacion real siempre la hace el backend).
function decodeJwtPayload(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
        .join("")
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

// true si el token no existe, esta mal formado, o ya expiro ("exp" en el pasado).
export function isTokenExpired(token) {
  if (!token) return true;
  const payload = decodeJwtPayload(token);
  if (!payload?.exp) return true;
  return Date.now() >= payload.exp * 1000;
}

export const AUTH_STORAGE_KEYS = [
  "token",
  "tokenadmin",
  "access_token",
  "refresh_token",
  "role",
  "activeButtonAdmin",
  "activeButtonUser",
];

export function clearAuthStorage() {
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
}
